import React, { useState, useEffect } from 'react';
import Map from '../map/map'
import Ebola from '../dashboard/ebola'
function Home() {
  // Declare a new state variable, which we'll call "count"
  


  return (
    <div>
      <h1>We are in Home</h1>
    </div>
  );
}

export default Home;
